// extracted by mini-css-extract-plugin
export default {"container":"cookies_container__UMT+q","textStyle":"cookies_textStyle__zapRc","buttonStyle":"cookies_buttonStyle__9KIrl"};